/* eslint-disable @typescript-eslint/no-unused-vars */

interface configProps {
  VITE_REACT_APP_URL: string;
  VITE_REACT_API_URL: string;
  VITE_REACT_PATH_IMAGE: string;
  VITE_GOOGLE_RECAPCHA_SITE_KEY: string;
  VITE_REACT_TINY_API_KEY: string;
  VITE_REACT_TINY_API_KEY_2: string;
  VITE_WEBSOCKET: string;
  VITE_SSE: string;
  VITE_POLL: string;
  VITE_REACT_API_PUBLIC_URL: string;
}

declare const window: Window &
  typeof globalThis & {
    config: configProps;
  };
const urlPage = window?.location?.href;
export let VITE_REACT_APP_URL = import.meta.env.VITE_REACT_APP_URL || window?.config?.VITE_REACT_APP_URL;
export let VITE_REACT_API_URL = import.meta.env.VITE_REACT_API_URL || window?.config?.VITE_REACT_API_URL;
export let VITE_REACT_PATH_IMAGE = import.meta.env.VITE_REACT_PATH_IMAGE || window?.config?.VITE_REACT_PATH_IMAGE;
export let VITE_GOOGLE_RECAPCHA_SITE_KEY = import.meta.env.VITE_GOOGLE_RECAPCHA_SITE_KEY || window?.config?.VITE_GOOGLE_RECAPCHA_SITE_KEY;
export let VITE_REACT_TINY_API_KEY = import.meta.env.VITE_REACT_TINY_API_KEY || window?.config?.VITE_REACT_TINY_API_KEY;
export let VITE_REACT_TINY_API_KEY_2 = import.meta.env.VITE_REACT_TINY_API_KEY_2 || window?.config?.VITE_REACT_TINY_API_KEY_2;
export let VITE_WEBSOCKET = import.meta.env.VITE_WEBSOCKET || window?.config?.VITE_WEBSOCKET;
export let VITE_SSE = import.meta.env.VITE_SSE || window?.config?.VITE_SSE;
export let VITE_POLL = import.meta.env.VITE_POLL || window?.config?.VITE_POLL;
export let VITE_REACT_API_PUBLIC_URL = import.meta.env.VITE_REACT_API_PUBLIC_URL || window?.config?.VITE_REACT_API_PUBLIC_URL;

if (urlPage.includes('localhost') || urlPage.includes('127.0.0.1')) {
  VITE_REACT_APP_URL = 'https://lotto-demo.jedloo.com/';
  VITE_REACT_API_URL = 'https://lotto-demo.jedloo.com/api/v1/';
  VITE_REACT_PATH_IMAGE = 'https://lotto-demo.jedloo.com/public/';
  // VITE_REACT_TINY_API_KEY = 'xt7azdpzok9aaxujav6q58jdg25p6zhs1954ryy1p48ps0t6';
  VITE_REACT_TINY_API_KEY = 'prei5j3rtu6xtc8tlb5h735p4yfp7svh1ocv0za172nan398';
  VITE_REACT_TINY_API_KEY_2 = 'prei5j3rtu6xtc8tlb5h735p4yfp7svh1ocv0za172nan398';
  VITE_GOOGLE_RECAPCHA_SITE_KEY = '';
  VITE_WEBSOCKET = 'http://localhost';
  VITE_SSE = 'https://lotto-demo.jedloo.com';
  VITE_POLL = 'https://lotto-demo.jedloo.com';
  VITE_REACT_API_PUBLIC_URL = 'https://lotto-demo.jedloo.com';
} else {
  VITE_REACT_APP_URL = 'https://lotto-demo.jedloo.com/';
  VITE_REACT_API_URL = 'https://demo-api.jedloo.com/api/v1/';
  VITE_REACT_PATH_IMAGE = 'https://demo-api.jedloo.com/public/';
  // VITE_REACT_TINY_API_KEY = 'xt7azdpzok9aaxujav6q58jdg25p6zhs1954ryy1p48ps0t6';
  VITE_REACT_TINY_API_KEY = 'prei5j3rtu6xtc8tlb5h735p4yfp7svh1ocv0za172nan398';
  VITE_REACT_TINY_API_KEY_2 = 'prei5j3rtu6xtc8tlb5h735p4yfp7svh1ocv0za172nan398';
  VITE_GOOGLE_RECAPCHA_SITE_KEY = '';
  VITE_WEBSOCKET = 'https://demo-api.jedloo.com';
  VITE_SSE = 'https://demo-api.jedloo.com';
  VITE_POLL = 'https://demo-api.jedloo.com';
  VITE_REACT_API_PUBLIC_URL = 'https://demo-api.jedloo.com';
}
